// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__MNR8h","title":"styles_title__tWFYU","description":"styles_description__mN4LT","btn":"styles_btn__YgGo0"};